module.exports = __webpack_public_path__ + "static/media/01.80768b57.jpg";